import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,
  Table,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getISTDate } from "../../../utils/Constant";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
import api2 from "../../../utils/Url2";
type Props = {};
const FuelTypeAdd = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValues } = getISTDate();
  const { defaultValuestime } = getISTDate();

  const [toaster, setToaster] = useState(false);
  const initialRowData = {
    activeClass: "",
    all: true,
    showExisting: true,
    isSuccess: true,
    message: "",
    srno: 0,
    eScarp: true,
    eScarpPrevValue: "",
    css: "",
    fuelTypeId: 0,
    fuelTypename: "",
    shortName: "",
    fuelCode: "",
    createdBy: "",
    updatedBy: "",
    createdOn: defaultValuestime,
    updatedOn: defaultValuestime

  };

  const [lang, setLang] = useState<Language>("en");
  const location = useLocation();



  useEffect(() => {

  }, []);
  const formik = useFormik({
    initialValues: {
      "activeClass": "",
      "all": true,
      "showExisting": true,
      "isSuccess": true,
      "message": "",
      "srno": 0,
      "eScarp": true,
      "eScarpPrevValue": "",
      "css": "",
      "fuelTypeId": 0,
      "fuelTypename": "",
      "shortName": "",
      "fuelCode": "",
      "createdBy": "",
      "updatedBy": "",
      "createdOn": defaultValuestime,
      "updatedOn": defaultValuestime

    },

    validationSchema: Yup.object({
      fuelTypename: Yup.string()
        .required(t("text.reqFuelType")),
        // .min(2, "fuel Type Name must be at least 2 characters")
        // .max(50, "fuel Type Name cannot exceed 50 characters"),
        fuelCode: Yup.string()
        .required(t("text.reqFuelCode")),
        // .min(1, "Fuel Code must be at least 1 character")
        // .max(10, "Fuel Code cannot exceed 10 characters"),
        shortName: Yup.string()
        .required(t("text.reqShortName"))
        // .min(2, "Short Name must be at least 2 characters")
        // .max(20, "Short Name cannot exceed 20 characters"),
    }),

    onSubmit: async (values) => {
      const response = await api.post(`FuelType/AddUpdateFuelType`, values);
      if (response.data.isSuccess) {
        setToaster(false);
        toast.success(response.data.msg);
        navigate("/vehiclemanagement/fueltype");
      } else {
        setToaster(true);
        toast.error(response.data.msg);
      }
    },
  });
  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.FuelTypeAdd")}
          </Typography>
          <Grid container justifyContent="flex-end">
            <Grid item lg={2} md={2} xs={12} marginTop={2}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>



            <Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.FuelTypeName")} required={true} />}
    variant="outlined"
    fullWidth
    size="small"
    name="fuelTypename"
    id="fuelTypename"
    value={formik.values.fuelTypename}
    placeholder={t("text.FuelTypeName")}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
   // required={true}
  />
  {formik.touched.fuelTypename && formik.errors.fuelTypename ? (
    <div style={{ color: "red", margin: "5px" }}>
      {formik.errors.fuelTypename}
    </div>
  ) : null}
</Grid>

<Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.FuelCode")} required={true} />}
    variant="outlined"
    fullWidth
    size="small"
    name="fuelCode"
    id="fuelCode"
    value={formik.values.fuelCode}
    placeholder={t("text.FuelCode")}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
  />
  {formik.touched.fuelCode && formik.errors.fuelCode ? (
    <div style={{ color: "red", margin: "5px" }}>
      {formik.errors.fuelCode}
    </div>
  ) : null}
</Grid>

<Grid item xs={12} sm={4} lg={4}>
  <TextField
    label={<CustomLabel text={t("text.FuelShortName")} required={true} />}
    variant="outlined"
    fullWidth
    size="small"
    name="shortName"
    id="shortName"
    value={formik.values.shortName}
    placeholder={t("text.FuelShortName")}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    //required={true}
  />
  {formik.touched.shortName && formik.errors.shortName ? (
    <div style={{ color: "red", margin: "5px" }}>
      {formik.errors.shortName}
    </div>
  ) : null}
</Grid>



              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.save")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default FuelTypeAdd;